;(function () {
  const html = document.documentElement
  const toggle = document.querySelector('.theme-switch')
  if (!toggle) return

  function system() {
    html.classList.remove('dark-theme', 'light-theme')
    localStorage.removeItem('theme')
    toggle.setAttribute('title', 'System')
  }

  function dark() {
    html.classList.remove('light-theme')
    html.classList.add('dark-theme')
    localStorage.setItem('theme', 'dark')
    toggle.setAttribute('title', 'Dark')
  }

  function light() {
    html.classList.remove('dark-theme')
    html.classList.add('light-theme')
    localStorage.setItem('theme', 'light')
    toggle.setAttribute('title', 'Light')
  }

  switch (localStorage.getItem('theme')) {
    case 'dark':
      dark()
      break
    case 'light':
      light()
      break
    default:
      system()
      break
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault()

    if (!html.classList.contains('dark-theme') && !html.classList.contains('light-theme')) {
      dark()
    } else if (html.classList.contains('dark-theme')) {
      light()
    } else {
      system()
    }
  })
})()
